import { motion, useScroll, useSpring } from "framer-motion";

export const ScrollProgress = () => {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 30, mass: 0.4 });
    return (
        <motion.div
            data-testid="scroll-progress"
            aria-hidden="true"
            style={{ scaleX }}
            className="fixed inset-x-0 top-0 z-[70] h-[2px] origin-left bg-rz-red"
        />
    );
};
